export default "__VITE_ASSET__Bc3Yzbuo__"